import { render, staticRenderFns } from "./regSearch.vue?vue&type=template&id=2a8a1cce"
import script from "./regSearch.vue?vue&type=script&lang=js"
export * from "./regSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports